/** Default visible columns in left-to-right display order (table schema order can differ). */
export const CLAIMS_TABLE_DEFAULT_VISIBLE_KEYS = [
  'claim_name',
  'tenant1',
  'rider_id',
  'claim_status',
  'claim_file_status',
  'app_type',
  'rider_damage_coverage_amount',
  'total_indemnity_payments',
  'bond_issue_date',
  'actions',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const CLAIMS_TABLE_STORAGE_KEY = 'claims-list-v4';
